<template>        
    <div id="appRoot"> 
        <template v-if="$route.meta.guest || $route.meta.public">
            <v-app>
                <transition>
                    <keep-alive>
                        <v-slide-y-transition mode="out-in">
                            <router-view></router-view>
                        </v-slide-y-transition>
                    </keep-alive>
                </transition>
            </v-app>
        </template>
        <template v-else-if="$route.meta.guest === false">
            <v-app>                                    
                <app-toolbar class="app--toolbar"></app-toolbar> 
                <!--<app-left-drawer class="app-left-drawer"></app-left-drawer>-->
                <app-content class="app--content"></app-content>                        
                <!--<app-fab></app-fab>-->
                <widget-fetch></widget-fetch>                   
            </v-app>            
        </template>        
        <app-snackbar></app-snackbar>   
        <a target="_blank" :href="'https://api.whatsapp.com/send?phone='+$config.cp.wa"><img class="elevation-3" style="position:fixed; width:60px; border-radius:50%; right:20px; bottom:20px; z-index:1000" src="@/assets/img/wa.png" /></a>
    </div>        
</template>

<script>
import AppFab        from './components/app/Fab';
import AppToolbar    from './components/app/Toolbar';
import AppLeftDrawer from './components/app/LeftDrawer';
import AppContent    from './components/app/Content';
import AppSnackbar   from './components/app/Snackbar';
import WidgetFetch   from './components/widgets/Fetch';
import AppEvents     from '@/event';
import User          from '@/util/models/User';

export default {
    name: 'App',
    components: {        
        AppFab,   
        AppToolbar,
        AppLeftDrawer,
        AppContent,
        AppSnackbar,
        WidgetFetch,
    },
    data() {
        return {            
                 
        }
    },
    created() {
        window.getApp = this;          
    },   
    mounted(){              
        AppEvents.forEach(item => {
            this.$on(item.name, item.callback);
        });
    },
    watch:{
        $route (to, from){   
            if(to.name === 'dashboard'){
                User.isLogin();
            }
            //console.log(to, from);
            //let attr = User.info().attr;
            //document.title = attr ? attr.name : this.$config.title;
            /*if(Device.cek()){
                if(User.isLogin()){
                   //console.log(User.info());
                    //this.synch = true;
                }
            } */           
        },
    }    
    
}
</script>
<style>
    .v-content{
        min-height: 100%;
        padding-bottom:200px;
    }
    .v-footer{
        position:absolute; bottom:0px; width:100%; height: auto; bottom: 0px; margin-top: 100px;
    } 
    .swal2-container, #appRoot {
        font-family: 'Roboto', sans-serif;
    }
    #swal2-content {
        font-family: arial
    }    
    .v-tooltip a{
        width:40px;
        height:42px;                
        top:0px;
        left:0px;
    }   
    .v-tooltip button{
        width:40px;
        height:42px;                
        top:0px;
        left:0px;
    }
    button .v-tooltip i{
        margin-top:10px
    }
    a{
        text-decoration: none;
    }
    .tabs-scroll{
        height: calc(100vh - 145px);      
        overflow-y: auto;            
    }
    .dapil-scroll{
        height: calc(100vh - 225px);      
        overflow-y: auto;            
    }
    .branch-scroll{
        height: calc(100vh - 161px);      
        overflow-y: auto;            
    }
    .bottom-scroll{
        height: calc(100vh - 64px);      
        overflow-y: auto;      
        z-index:2;
    }
    .live-scroll{
        height: calc(100vh - 64px);      
        overflow-y: auto;              
    }
    @media only screen and (max-width: 1000px) and (min-width:500px) {
        .dapil-scroll{height: calc(100vh - 180px);}
        .tabs-scroll{height: calc(100vh - 130px);}
        .branch-scroll{height: calc(100vh - 133px);}
        .bottom-scroll{height: calc(100vh - 50px);}
    }
    @media only screen and (max-width: 500px) {
        .dapil-scroll{height: calc(100vh - 205px);}
        .tabs-scroll{height: calc(100vh - 140px);}
        .branch-scroll{height: calc(100vh - 148px);}
        .bottom-scroll{height: calc(100vh - 57px);}
    }
     .tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
        padding: 0 4px;
    }
    .tabular table.v-table tbody td:first-child, .tabular table.v-table thead th:first-child, .tabular table.v-table tfoot td:first-child{
        padding: 0 4px 0 12px;
    }
    .nopadding table.v-table tbody td:first-child, .nopadding table.v-table thead th:first-child, .nopadding table.v-table tfoot td:first-child{
        padding: 0px;
    }
    .cursor{
      cursor: pointer;
    }
    .list-select{border-left: 3px solid #11E611;}
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
      -webkit-appearance: none; 
      margin: 0; 
    }
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>
